import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'processDate', standalone: true })
export class ProcessDatePipe implements PipeTransform {
  private readonly datePipe = new DatePipe('en-US');
  private readonly monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'long', timeZone: 'UTC' });

  transform(value: string | null | undefined, kind: 'posting' | 'processed' = 'posting'): string {
    if (kind === 'processed') return this.formatProcessed(value);
    if (!value || !/^(?:\d{6}|\d{8})$/.test(value)) return value ?? '';
    const year = value.slice(0, 4);
    const month = Number(value.slice(4, 6));
    const day = value.length === 8 ? Number(value.slice(6, 8)) : 1;
    const date = this.calendarDate(Number(year), month, day);
    if (!date) return value;
    return value.length === 8 ? `${month}/${day}/${year}` : `${this.monthFormatter.format(date)} ${year}`;
  }

  private formatProcessed(value: string | null | undefined): string {
    const raw = value ?? '';
    const text = raw.trim();
    if (!text) return 'Not processed';
    const date = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)?)?$/.exec(text);
    if (!date || !this.calendarDate(Number(date[1]), Number(date[2]), Number(date[3]))) return raw;
    if (/^0001-01-01(?:[T ]00:00(?::00(?:\.0+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/.test(text))
      return 'Not processed';
    try {
      return this.datePipe.transform(text, 'M/d/yyyy h:mm:ss a') ?? raw;
    } catch {
      return raw;
    }
  }

  private calendarDate(year: number, month: number, day: number): Date | null {
    if (year < 1 || month < 1 || month > 12 || day < 1) return null;
    const date = new Date(0);
    date.setUTCFullYear(year, month - 1, day);
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day ? date : null;
  }
}
